<template>
  <div id="app">
    <div class="head-app" v-show="showGuide === '1'">
      <img @click="goout" src="https://xi-jiu-you.oss-cn-hangzhou.aliyuncs.com/shop/202312/back-icon-btn.png" alt="">
      <p>{{name}}</p>
    </div>
    <router-view/>
  </div>
</template>

<script>
export default {
  data(){
    return{
      name:"",
      showGuide:"",
    }
  },
  watch:{
    $route(res){
      console.log(res)
      const time = setTimeout(()=>{
        this.showGuide = res.query.showGuide;
        this.name = res.meta.title;
        clearTimeout(time);
      },200)
    }
  },
  mounted(){
    // console.log(router)
    // const time = setTimeout(()=>{
    //   this.showGuide = this.$route.query.showGuide;
    //   this.name = this.$route.meta.title;
    //   clearTimeout(time);
    // },200)
    
  },
  methods:{
    goout(){
      window.history.back()
    }
  }
}
</script>
<style scoped>
.head-app{
  position: relative;
  height: 50px;
  line-height: 50px;

}
.head-app img{
  position: absolute;
  width: 20px;
  height: 20px;
  left: 20px;
  top: 15px;
}
</style>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
*{
  padding: 0;
  margin: 0;
}
nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
